import script from "./SellForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SellForm.vue?vue&type=script&setup=true&lang=ts"

import "./SellForm.vue?vue&type=style&index=0&id=0274966b&lang=scss&scoped=true"
import "./SellForm.vue?vue&type=style&index=1&id=0274966b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0274966b"]])

export default __exports__